import React from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import Information from '../../../../icons/information'

const Container = styled.div`
  font-family: ${theme('typography.paragraph.fontFamily')};
  display: flex;
  margin-top: ${theme('temporarilyClosed.marginTop')};
  background-color: ${theme('colors.boxColor')};
  padding: ${theme('temporarilyClosed.padding')};
  border-radius: ${theme('temporarilyClosed.borderRadius')};
`

const IconContainer = styled.div`
  width: ${theme('temporarilyClosed.icon.width')};
  display: flex;
  justify-content: center;
  align-items: center;
`

const Text = styled.div`
  padding-left: ${theme('temporarilyClosed.text.paddingLeft')};
  font-family: ${theme('typography.paragraph.fontFamily')};
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    margin: 0;
  }
`

const TemporarilyClosed = ({ text, children }) => (
  <Container>
    <IconContainer>
      <Information width={26} height={26} />
    </IconContainer>
    <Text
      dangerouslySetInnerHTML={
        children
          ? undefined
          : {
              __html: text,
            }
      }
    >
      {children}
    </Text>
  </Container>
)

export default TemporarilyClosed
